module.exports = __webpack_public_path__ + "img/404.29c46630.svg";